import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit, PLATFORM_ID,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LeagueHomeService } from '@core/services/league-home.service';
import {
  League,
  componentDestroyed,
  UntilDestroy,
  LeagueCourt, BannerLocation, TournamentApi, Tournament, TournamentTypes
} from '@mtgame/core';
import { Title } from '@angular/platform-browser';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { LayoutService } from '../../layout/layout.service';
import { takeUntil } from 'rxjs/operators';
import { LeagueRootService } from '@core/services/league-root.service';
import { combineLatest } from 'rxjs';

@UntilDestroy
@Component({
  selector: 'mtg-league-home',
  templateUrl: './league-home.component.html',
  styleUrls: ['./league-home.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LeagueHomeComponent implements OnInit, OnDestroy {
  league: League;
  tournaments: Tournament[] = [];
  tournamentTypes = TournamentTypes;
  courts: LeagueCourt[] = [];
  isBrowser = isPlatformBrowser(this.platformId);
  bannerLocations = BannerLocation;

  constructor(
    private route: ActivatedRoute,
    private leagueRootService: LeagueRootService,
    private leagueHomeService: LeagueHomeService,
    private tournamentApi: TournamentApi,
    private cdr: ChangeDetectorRef,
    private title: Title,
    private layoutService: LayoutService,
    @Inject(DOCUMENT) private doc: Document,
    @Inject(PLATFORM_ID) private platformId: string,
  ) {
  }

  async ngOnInit() {
    this.leagueRootService.league$
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(league => {
        this.league = league;
        this.title.setTitle(league.name);
        this.cdr.markForCheck();
      });

    combineLatest([
      this.leagueRootService.league$.pipe(takeUntil(componentDestroyed(this))),
      this.leagueRootService.tournaments$.pipe(takeUntil(componentDestroyed(this))),
      this.leagueHomeService.courts$.pipe(takeUntil(componentDestroyed(this)))
    ]).subscribe(([league, tournaments, courts]) => {
      this.league = league;
      this.tournaments = tournaments.filter(item => !item.settings.hideOnLeagueMainPage);
      this.courts = courts;
      this.cdr.markForCheck();
    });

    if (this.isBrowser) {
      this.leagueHomeService.getCourts();
    }
  }

  ngOnDestroy(): void {
    this.leagueHomeService.dispose();
  }
}


